import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./IcuMian.css";
import icubanner from "../assets/images/icu_banner.png";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import call from "../assets/images/call.png";
import patient from "../assets/images/patient.png";
import ExpertNurses from "../assets/images/ExpertNurses.png";
import CitiesCovered from "../assets/images/CitiesCovered.png";
import SupportAvailable from "../assets/images/SupportAvailable.png";

import icuImage from "../assets/images/icuImage.png";
import hospicu from "../assets/images/hospicu.png";
import { useState } from "react";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import { Modal } from "react-bootstrap";
import CountUp from "react-countup";
import Testimonial from "../layout/Home/Testimonial";
import Review from "../layout/Home/Review";
import Faq from "../layout/Home/Faq";

import faqimage from "../assets/images/icu-hospital-faq.jpg";
import Accordion from "react-bootstrap/Accordion";
import FaqData from "../layout/Faqdata"; 

const steps = [
  {
    id: 1,
    title: "Book Online",
    desc: "Fill the form or call us",
  },
  {
    id: 2,
    title: "Assessment Call",
    desc: "Doctor reviews patient needs",
  },
  {
    id: 3,
    title: "Equipment Setup",
    desc: "Team arrives with all gear",
  },
  {
    id: 4,
    title: "Care Begins",
    desc: "Nurse starts 24/7 care",
  },
];

export default function IcuHospital() {
  const [show, setShow] = useState(false);
  return (
    <>
      <Header />

      <div className="icu_banner_sec icu-hospital-banner">
        <div className="row">
          <div className="col-lg-6">
            <div className="text_icu_banner">
              <p className="subtitle_icu_banner">
                India’s Trusted ICU Home Care
              </p>
              <h1 className="heading_icu_banner">
                ICU Setup At <span>Hospital</span>
              </h1>
              <p className="pera_icu_banner">
                Receive advanced ICU setup at the hospital with experienced specialists, trained ICU nurses, modern life-support systems, and 24×7 critical care monitoring.
              </p>
              <div className="icu_banner_btns">
                <div className="icu_at_home_btn">
                  <Link to="/icu-installation-enquiry">Book Now</Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6"
            style={{
              backgroundImage: `url(${hospicu})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        </div>
      </div>

      {/* <section className="icusetup_service_sec">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Our Services</span>
              <h2>
                What We <span>Provide</span>
              </h2>
              <p>
                Compassionate nursing care, physiotherapy, and bedside
                assistance tailored for patient comfort, recovery, and daily
                healthcare support.
              </p>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="icusetup_outer">
                <h3>
                  <HomeRoundedIcon />
                  Home ICU Setup
                </h3>
                <p>
                  Advanced ICU care in the comfort of your home. Our Home ICU
                  Setup service provides hospital-grade medical equipment,
                  continuous patient monitoring, and skilled healthcare
                  professionals to ensure critical care support without the need
                  for prolonged hospital stays. We create a safe and comfortable
                  recovery environment tailored to your medical needs.
                </p>
                <div className="getstart">
                  <button> <Link to="/icu-home-assesment">Get Started</Link> </button>
                  <div className="call_us">
                    <img src={call} alt="" />
                    <div className="text">
                      <label htmlFor="">Call Us Anytime</label>
                      <p>+91 87399 90555</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="icusetup_outer">
                <h3>
                  <HomeRoundedIcon />
                  Hospital ICU Setup
                </h3>
                <p>
                  Advanced ICU care in the comfort of your home. Our Home ICU
                  Setup service provides hospital-grade medical equipment,
                  continuous patient monitoring, and skilled healthcare
                  professionals to ensure critical care support without the need
                  for prolonged hospital stays. We create a safe and comfortable
                  recovery environment tailored to your medical needs.
                </p>
                <div className="getstart">
                  <button> <Link to="/icu-home-assesment">Get Started</Link> </button>
                  <div className="call_us">
                    <img src={call} alt="" />
                    <div className="text">
                      <label htmlFor="">Call Us Anytime</label>
                      <p>+91 87399 90555</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="icu-section">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-lg-5">
              <div className="video-box" onClick={() => setShow(true)}>
                <img src={icuImage} alt="ICU Setup" />

                <div className="play-btn">
                  <PlayArrowRoundedIcon />
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-7">
              <div className="right-content">
                <span className="section-tag">Introduction</span>
                <h2>
                  {" "}
                  Advanced ICU Setup at <span>Hospital</span> in Jaipur{" "}
                </h2>
                <p>
                  Our <a href="/icu-installation-at-hospital">ICU Setup at the hospital</a>  provides advanced critical care for patients who require continuous medical supervision, life-support systems, and specialized treatment. Equipped with modern ICU technology and managed by experienced intensivists, critical care physicians, and trained ICU nurses, our intensive care unit ensures every patient receives timely, safe, and evidence-based medical care in a highly monitored environment.
                </p>

                <ul className="service-list">
                  <li>Advanced Critical Care</li>
                  <li>24×7 Intensive Monitoring</li>
                  <li>Certified Critical Care Team</li>
                  <li>Advanced Life Support</li>
                  <li>Round-the-Clock Medical Support</li>
                  <li>Personalized Treatment Plans</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="stats-box">
            <div className="stat-item">
              <img src={patient} alt="icu-hospital-icon-1" />
              <h3>
                <CountUp
                  start={0}
                  end={5000}
                  duration={7}
                  delay={0.5}
                  enableScrollSpy
                  scrollSpyOnce
                />
                <label>+</label>
              </h3>

              <p>Patients Successfully Treated</p>
            </div>

            <div className="stat-item">
              <img src={ExpertNurses} alt="icu-hospital-icon-2" />
              <h3>
                <CountUp
                  start={0}
                  end={200}
                  duration={7}
                  delay={0.5}
                  enableScrollSpy
                  scrollSpyOnce
                />
                <label>+</label>
              </h3>
              <p>Experienced ICU Professionals</p>
            </div>

            <div className="stat-item">
              <img src={SupportAvailable} alt="icu-hospital-icon-3" />
              <h3>24/7</h3>
              <p>Critical Care Monitoring</p>
            </div>

            <div className="stat-item">
              <img src={CitiesCovered} alt="icu-hospital-icon-4" />
              <h3>Advanced</h3>
              <p>Life-Support Infrastructure</p>
            </div>
          </div>        
        </div>
      </section>

      <section className="whychse">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Why Choose Us</span>
              <h3>
                Why Families Trust Our <span>ICU Services </span>
              </h3>
              <p>
                Receive advanced <a href="/icu-installation-at-hospital">ICU Services At Hospital</a> from experienced critical care specialists, modern ICU technology, and dedicated medical professionals committed to providing the highest standard of patient care.

              </p>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Certified Critical Care Specialists</h3>
                <p>
                  Our ICU team consists of experienced intensivists, physicians, and certified ICU nurses trained to manage complex medical conditions.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <LocalOfferOutlinedIcon />
                <h3>Continuous Critical Care</h3>
                <p>
                 24×7 patient monitoring, emergency response, and coordinated treatment ensure timely medical intervention whenever needed.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Transparent & Affordable Care</h3>
                <p>
                  Comprehensive ICU services with transparent pricing and personalized treatment plans focused on patient well-being.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <AddShoppingCartOutlinedIcon />
                <h3>Modern ICU Equipment</h3>
                <p>
                  Advanced ICU facilities featuring ventilators, multipara monitors, infusion pumps, oxygen therapy, and essential life-support equipment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="process-section">
        <div className="container-fluid">
          <div className="process-wrapper">
            <div className="section_heading">
              <div className="content_part text-center col-lg-12  col-sm-12 col-12">
                <span className="short_title text-white">Process</span>
                <h2 className="text-white">
                  How It <span>Works</span>
                </h2>
                <p className="text-white">
                  {" "}
                  ICU setup at your home in 4 easy steps
                </p>
              </div>
            </div>

            <div className="steps-row">
              <div className="process-line"></div>

              {steps.map((step) => (
                <div key={step.id} className="step-item">
                  <div className="step-circle">
                    <span>{step.id}</span>
                  </div>

                  <h4>{step.title}</h4>

                  <p>{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <Testimonial />
      {/* <Review /> */}
      {/* <Faq /> */}

      <div className="faq_sec">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="section_heading ">
                          <h4>
                            Frequently Asked <span>Questions </span>
                          </h4>
                        </div>
                        <div className="faq-image">
                          <img src={faqimage} alt="icu-hospital-faq-img" className="img-fluid" />
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="faq-main">
                           <Accordion defaultActiveKey="0">
                              {FaqData
                                .filter((item) => item.page === "icuhospital")
                                .map((item, index) => (
                                  <Accordion.Item
                                    eventKey={index.toString()}
                                    key={item.id}
                                  >
                                    <Accordion.Header as="h5">{item.title}</Accordion.Header>
                                    <Accordion.Body>{item.content}</Accordion.Body>
                                  </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

      <Footer />

      {/* Video Modal */}

      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <Modal.Body className="p-0">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/-pLqLys71Yg?si=7eex51pxLasjKwAQ"
            title="YouTube video"
            allow="autoplay"
            allowFullScreen
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
